import FileSaver from "file-saver";
import * as XLSX from "xlsx";

export default function downloadXlsxModel<T extends object>(
  data: T,
  fileName: string
): void {
  const headers = Object.keys(data);
  const worksheet = XLSX.utils.json_to_sheet([data], { header: headers });
  const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  const xlsxData = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  FileSaver.saveAs(xlsxData, `modelo_${fileName}.xlsx`);
}
